module.exports = __webpack_public_path__ + "static/mobile-footer-901b63f114197c70fb06609933e604f2.jpg";